import { history } from '../core/history';

export const gotoPage = (path: string) => {
	history.push(path);
	window.scrollTo({ top: 0 });
};
